import commonGetters from '@/store/data/common/getters'
import helpers from './helpers'
import { filter, map, split, head, isNil } from 'lodash'

const getters = {
    ...commonGetters,
    getAvailableCclones: state => () => {
        return filter(state.list, cclone => cclone.status === 'available')
    },

    getFormattedCclones: state => () => {
        const ccloneList = state.list

        const formattedCclones = []
        for (const cclone of ccloneList) {
            const data = {
                ...cclone,
                created_at: head(split(cclone.created_at, ' ')),
                start_date: head(split(cclone.start_date, ' ')),
                end_date: head(split(cclone.end_date, ' ')),
                positive_events: helpers.getCcloneInfo(cclone.positive_events, 'type'),
                positive_volume: isNil(cclone.scf_raw_data_result) ? 'N/A' : cclone.scf_raw_data_result.non_empty_positives,
                negative_events:
                    cclone.negative_events !== ''
                        ? helpers.getCcloneInfo(cclone.negative_events, 'type')
                        : cclone.settings.hasOwnProperty('3rdParty')
                            ? 'Full database'
                            : '1st Party Universe',
                negative_volume: isNil(cclone.scf_raw_data_result) ? 'N/A' : cclone.scf_raw_data_result.non_empty_negatives
            }
            formattedCclones.push(data)
        }
        return formattedCclones
    },

    // no getter here, should be moved to helpers
    getCclonesCoordinates: () => params => {
        return map(params.ccloneData, data => {
            const isSelected = params.selectedPoint[0] == data.coordinates[0] && params.selectedPoint[1] == data.coordinates[1]
            return {
                value: data.coordinates,
                symbolSize: isSelected ? 20 : 10,
                itemStyle: isSelected ? { color: '#c23531', shadowColor: '#c23531', shadowBlur: 3 } : {}
            }
        })
    }
}

export default getters
